module.exports = __webpack_public_path__ + "media/images/responsive/flow/suns_step_04-33a58509865eb98a7384786f2e140b07.jpg";